import type {RootState} from "../store";

function selectCourseEditing(state: RootState, courseKey: string): boolean {
	return state.ui.courseEditing.byKey[courseKey]?.editing ?? false;
}

export default selectCourseEditing;
